import React, {Component} from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { Dates } from '../../packages/dates';
import Ribbon from '../../components/RibbonNew';
import Scrollable from '../../components/Scrollable';
import MyRecordings, {EmptyContent} from '../../components/MyContent/MyRecordings';
import Translator from '../../requests/apa/Translator';
import Npvr from '../../utils/Npvr';
import ChannelSingleton from '../../components/Epg/ChannelsSingleton';
import Device from '../../devices/device';
import {
  HIDE_MODAL,
  MODAL_ACCIONES_CONTENIDO,
  MODAL_EPG
} from '../../actions/modal';
import store from '../../store';
import LocalStorage from '../DeviceStorage/LocalStorage';

import Utils from '../../utils/Utils';
import PlayerStreamingUtils from '../../utils/PlayerStreamingUtils';
import {NpvrUtil} from '../../AAF/Npvr/NpvrUtil';
import NpvrUploader from '../../AAF/Npvr/NpvrUploader';
import EpgPersistence from '../../AAF/Nepg/EpgPersistence';
import logger from 'src/utils/logger/logger';

class MyContent extends Component {
  state = {
    isLoading: true,
    ribbons: []
  };


  componentDidMount() {
    const ribbons =
      this.props.ribbonsUser.length > 0
        ? this.props.ribbonsUser
        : [];
    if (ribbons.length > 0) {
      this.getRibbons(ribbons);
    }
  }

  componentWillReceiveProps(next_props) {
    const ribbons =
      this.props.ribbonsUser.length > 0
        ? this.props.ribbonsUser
        : next_props.ribbonsUser.length > 0
        ? next_props.ribbonsUser
        : [];
    if (ribbons.length > 0) {
      this.getRibbons(ribbons);
    }
  }

  componentDidUpdate() {
    window.SpatialNavigation.focus('.ribbon-items .focusable');
  }

  getRibbons = async ribbonsUser => {
    ribbonsUser.map(it => {
      it.showFooter = true;
      it.title = it.id.replace('-', ' ').replace('-', ' ');
      return it;
    });
    const ribbons = await this.getRibbonsItems(ribbonsUser);
    if (NpvrUtil.recordingIconEnable().enable) {
      NpvrUploader.getRecordings().then(() => {
        NpvrUploader.updateLocalRecordings();
      });
    }
    this.setState({
      ribbons: ribbons,
      isLoading: false
    });
  };

  getRibbonsItems = async ribbons => {
    for (let i = 0; i < ribbons.length; i++) {
      const items = await this.getUserRecordingsFromUrl(ribbons[i].url);
      ribbons[i].items = items;
    }
    return ribbons;
  };

  parseRecordings = (recordings, timeUsed) => {
    return recordings.map(record => {
      const {channel, pack_id: packId, actions, status, date} = record;
      const {event} = channel;
      const eventid_programme_id = event.id + '-' + record.record_id;
      let dateOfEvent = event.date_begin;
      const title = event.name;
      const group_id = event.group_id;
      const event_alf_id = event.event_alf_id
      //const isSeries = event.ext_series_id != 0;
      const isSeries = false;
      const dateOfRecord = EpgPersistence.needsOffset()
        ? new Dates(date, 'YYYY-MM-DDThh:mm:ssZ')
          .utcOffset(EpgPersistence.needsOffset(), false)
          .format("dddd DD/MM/YYYY 'a las' HH:mm'hs.'")
        : new Dates(date, 'YYYY-MM-DDThh:mm:ssZ').format(
          "dddd DD/MM/YYYY 'a las' HH:mm'hs.'"
        ); //Se sustituye por dateOfEvent
      dateOfEvent = EpgPersistence.needsOffset()
        ? new Dates()
          .unix(dateOfEvent)
          .utcOffset(EpgPersistence.needsOffset(), false)
          .format("dddd DD/MM/YYYY 'a las' HH:mm'hs.'")
        : new Dates().unix(dateOfEvent).format("dddd DD/MM/YYYY 'a las' HH:mm'hs.'");

      return {
        event_id: event.id,
        event_alf_id,
        group_id: group_id,
        cover: channel.event.ext_eventimage_name.replace('https://', 'http://'),
        title,
        description: event.description,
        node: 'myRecords',
        record_id: record.record_id,
        eventid_programme_id,
        status,
        label: this.getRecordStatusLabel(status),
        actions,
        used:
          typeof timeUsed['pack_' + packId] === 'number'
            ? timeUsed['pack_' + packId]
            : 0, // minutes,
        limit: ChannelSingleton.getMaxNpvrStorage(), //ChannelSingleton.getNpvrStorage(channel.group_id),
        isRecord: true,
        dateOfRecord: isSeries ? null : dateOfRecord,
        date_begin: event.date_begin ? event.date_begin : null,
        date_end: event.date_end ? event.date_end : null,
        duration: event.duration ? event.duration : null,
        dateOfEvent: isSeries ? null : dateOfEvent,
        isSeries, //alcance de serie todavia no para esta version
        isRecording: status === 'recording',

        clickHandler: e => {
          this.props.handleRecordingPlay(group_id, title, actions, event);
        }
      };
    });
  }


  parseSeries = (series, timeUsed) => {
    return series.map(record => {
      const  { actions, serie_id, group_id, serie_name, image, pack_id: packId} = record;
      return {
        event_id: serie_id,
        group_id,
        cover: image.replace('https://', 'http://'),
        title: serie_name,
        node: 'myRecords',
        record_id: serie_id,
        ext_series_id: serie_id,
        //status:'',
        //label: this.getRecordStatusLabel(status),
        //isRecording: status === 'recording',
        actions,
        used:
          typeof timeUsed['pack_' + packId] === 'number'
            ? timeUsed['pack_' + packId]
            : 0, // minutes,
        limit: ChannelSingleton.getMaxNpvrStorage(), //ChannelSingleton.getNpvrStorage(channel.group_id),
        isRecord: true,
        isSeries: true,
        clickHandler: e => {
          this.handleRecordingSeries({timeUsed, actions})
        }
      };
    });
  }

  getUserRecordingsFromUrl = async url => {
    this.playerStreamingUtils = new PlayerStreamingUtils();
    const isRecordingsEnabled = this.playerStreamingUtils.getButtonRecord('npvr_button_record');
    if (isRecordingsEnabled) {
      try {
        const {user_token} = this.props.user;
        const result = NpvrUtil.recordingIconEnable().enable
          ? await NpvrUploader.listFromUrl(url)
          : await new Npvr().listFromUrl(user_token, url);
        const {time_used: timeUsed} = result;
        let myRecordings= [];
        const recordings = this.parseRecordings(result.recordings || [], timeUsed);
        const series = this.parseSeries(result.series || [], timeUsed);
        myRecordings = [...recordings, ...series];
        return myRecordings;
      } catch (e) {
        logger.error('Error getting recordings/list', e);
        return [];
      }
    } else {
      return [];
    }
  };


  getRecordStatusLabel = recordStatus => {
    switch (recordStatus) {
      case 'recording':
        return Translator.get('my_recordings_status_recording', 'Grabando');
      case 'ingested':
        return Translator.get('my_recordings_status_ingested', 'Listo');
      case 'scheduled':
      default:
        return Translator.get('my_recordings_status_scheduled', 'Pendiente');
    }
  };

  handleRecordingSeries = async ({ timeUsed, actions }) => {
    this.props.history.push(`${this.props.match.url}/series`, {
      timeUsed,
      actions
    });
  };

  setResumeData = (cardData, cb) => {
    cardData.showActionBtns = false;
    cardData.playButton = false;
    cardData.langButton = false;
    cardData.favouriteButton = false;
    cardData.purchaseButtonInfo = null;
    cardData.overWrite = true;
    this.props.setResumeData(cardData);
    if (typeof cb === 'function') {
      cb(cardData);
    }
  };

  ribbonsHasItems = ribbons => {
    return !Array.isArray(ribbons) || ribbons.length === 0
      ? false
      : ribbons.filter(it => it.items.length > 0).length > 0;
  };

  render() {
    const {ribbons} = this.state;
    return (
      <Scrollable height={'414px'}>
        {this.ribbonsHasItems(ribbons) ? (
          <MyRecordings
            render={callback =>
              ribbons.length === 0
                ? null
                : ribbons
                  .filter(r => r.items.length !== 0)
                  .map((it, i) => {
                    return (
                      <Ribbon
                        id={'recordings-' + i}
                        title={it.title}
                        items={it.items}
                        focusHandler={cardData => {
                          this.setResumeData(cardData, callback);
                        }}
                        type={'recordings'}
                        keyDownHandler={this.props.handleKeyPress}
                        setMetricsEvent={this.props.setMetricsEvent}
                        showFooter={it.showFooter}
                        user={this.props.user}
                        placeholder={it.placeholder}
                      />
                    );
                  })
            }
          />
        ) : this.state.isLoading ? null : (
          <div>
            <MyRecordings
              render={callback =>
              {
                setTimeout( () => {
                  callback({
                    'limit': ChannelSingleton.getMaxNpvrStorage(),
                    'used': 0
                  });
                } ,500);
              }
              }
            />
            <EmptyContent message={'No tienes grabaciones'} />
          </div>
        )}
      </Scrollable>
    );
  }
}

MyContent.propTypes = {
  user: PropTypes.func.isRequired,
  setResumeData: PropTypes.func.isRequired,
  setMetricsEvent: PropTypes.func.isRequired,
  handleKeyPress: PropTypes.func.isRequired,
  handleRecordingPlay: PropTypes.func.isRequired
};

MyContent.defaultProps = {
  user: {},
  setResumeData: () => null,
  setMetricsEvent: () => null,
  handleKeyPress: () => null,
  handleRecordingPlay: () => null
};

export default withRouter(MyContent);



// WEBPACK FOOTER //
// ./src/components/MyContent/index.jsx